import React from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
// import * as actions from '@Redux/detail/Group/actions';
import { RootState } from '@Redux/detail/store';
import { Difference } from '@components/Common/Icons';
import SchedulesList from './subComponents/SchedulesList';
import styles from './style.module.scss';

const GroupAllTours: React.FC = () => {
    const { Schedules } = useSelector((state: RootState) => state.groupReducer);

    return Schedules?.TourIDList && Schedules.TourIDList.length > 1 ? (
        <div className={cN(styles['group_all_schedules'], 'group_all_schedules')}>
            <div className={styles.titleBlock}>
                <div className={styles.leftBlock}>
                    <div className={styles.title}>選擇行程</div>
                    <div className={styles.note}>行程會依出發時間或景點安排而有所不同</div>
                </div>
                {Schedules.CompareUrl && (
                    <a
                        className={styles.travelDiff}
                        href={document.getElementById('removeTravelLevel') ? '' : '/travel' + Schedules.CompareUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <Difference />
                        <div className={styles.text}>行程差別</div>
                    </a>
                )}
            </div>
            <SchedulesList />
        </div>
    ) : null;
};

export default GroupAllTours;
